import React, { useEffect } from "react";
import SlidingPane from "react-sliding-pane";
import { ReactComponent as Closy } from "assets/svgs/closy.svg";
import { useSelector, useDispatch } from "react-redux";
import { TOGGLE_SCHEDULED_ORDERS_MODAL } from "utils/action-types";
import { isDesktop } from "utils/device-detect";
import { useGlobalContext } from "context/global";
import { fetchScheduledOrders } from "actions/account/subscription";
import Loader from "components/loader";
import DispatchedOrder from "./dispatched-order";
import BillingCycle from "./billing-cycle";

const ScheduledOrdersModal = () => {
	const { translation } = useGlobalContext();
	const { isScheduledOrdersModalOpen, subscriptionId, scheduledOrders } = useSelector((state) => state.account.subscription);
	const orders = Object.values(scheduledOrders);
	const dispatch = useDispatch();

	const toggle = () => {
		dispatch({ type: TOGGLE_SCHEDULED_ORDERS_MODAL });
	};

	useEffect(() => {
		if (!orders.length)
			dispatch(fetchScheduledOrders());
	}, [subscriptionId]);

	return (
		<>
			<SlidingPane
				from="right"
				width={isDesktop() ? "360px" : "90%"}
				shouldCloseOnEsc
				overlayClassName="z-50 bg-white mx-auto"
				isOpen={isScheduledOrdersModalOpen}
				hideHeader
				onRequestClose={toggle}
			>
				<div className="flex flex-col px-3 pt-5 pb-2.5 md:py-5 md:px-8 sticky top-0 z-[51] bg-white">
					<div className="flex justify-between rounded-t sticky top-0 bg-white z-10">
						<p className="text-body ">{translation.subscription?.change_billing_cycle}</p>
						<button onClick={toggle}>
							<Closy />
						</button>
					</div>
					<p className="text-gray-400 w-4/5">
						{translation?.subscription?.scheduled_orders_message}
					</p>
				</div>
				{!orders.length ? <Loader ring className="w-7 h-7 my-3" /> :
					<>
						<DispatchedOrder />
						{orders.map(cycle => cycle.status !== "SKIPPED" && <BillingCycle key={cycle.id} cycle={cycle} />)}
					</>}
			</SlidingPane>
		</>
	);
};

export default ScheduledOrdersModal;